import React from 'react'
import Paper from '@mui/material/Paper'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import makeStyles from '@mui/styles/makeStyles'
import styles from './_styles/contentPageStyles'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { root: { flexGr... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

const ContentPage = ({ title, subtitle, children }: any) => {
    const classes = useStyles()

    return (
        <Paper className={classes.paper}>
            <Card className={`no-padding-bottom-card ${classes.root}`}>
                <CardHeader
                    classes={{
                        title: classes.cardHeaderTitle,
                        subheader: classes.subCardHeaderTitle,
                    }}
                    style={{
                        textAlign: 'left',
                        paddingLeft: '10px',
                        paddingBottom: '0px',
                    }}
                    title={title}
                    subheader={subtitle}
                />
                {children}
            </Card>
        </Paper>
    )
}

export default ContentPage
